import { ScreenReaderText, Toast } from '@mlc/web-ui-toolkit';
import React, { Fragment, FunctionComponent, useEffect, useState } from 'react';
import {
	onErrorEvent,
	onInfoEvent,
	onLiveEvent,
	onSuccessEvent,
	removeListeners,
} from '../../../events/NotificationEmitter';

const ToastContainer: FunctionComponent = () => {
	const [message, setMessage] = useState<string | JSX.Element>();
	const [showSuccess, setShowSuccess] = useState(false);
	const [showError, setShowError] = useState(false);
	const [showInfo, setShowInfo] = useState(false);
	const [showLive, setShowLive] = useState(false);
	const [onCloseFn, setOnCloseFn] = useState<any>();

	useEffect(() => {
		onSuccessEvent((message: JSX.Element | string, onCloseFn?: () => any) => {
			closeAll();
			setOnCloseFn(() => onCloseFn);
			setMessage(message);
			setShowSuccess(true);
		});

		onErrorEvent((message: string, onCloseFn?: () => any) => {
			closeAll();
			setOnCloseFn(() => onCloseFn);
			setMessage(message);
			setShowError(true);
		});

		onInfoEvent((message: string, onCloseFn?: () => any) => {
			closeAll();
			setOnCloseFn(() => onCloseFn);
			setMessage(message);
			setShowInfo(true);
		});

		onLiveEvent((message: string) => {
			closeAll();
			setMessage(message);
			setShowLive(true);
		});
		return removeListeners;
	}, []);

	const closeAll = () => {
		setShowSuccess(false);
		setShowError(false);
		setShowInfo(false);
		setShowLive(false);
	};

	const closeToast = (setShowStateFunction: any) => {
		onCloseFn && onCloseFn();
		setMessage('');
		setShowStateFunction(false);
	};

	return (
		<Fragment>
			{!showError && message && (
				<ScreenReaderText
					data-id="toast-notification"
					id="toastNotificationMessage"
					role="region"
					aria-live={showLive ? 'assertive' : 'polite'}
				>
					{message}
				</ScreenReaderText>
			)}
			{showInfo && (
				<Toast
					data-id="info-toast"
					isVisible={showInfo}
					variant="warning"
					onClose={() => {
						closeToast(setShowInfo);
					}}
					message={message}
				/>
			)}
			{showError && (
				<Toast
					data-id="error-toast"
					isVisible={showError}
					variant="error"
					onClose={() => {
						closeToast(setShowError);
					}}
					message={message}
				/>
			)}
			{showSuccess && (
				<Toast
					data-id="success-toast"
					isVisible={showSuccess}
					variant="success"
					onClose={() => {
						closeToast(setShowSuccess);
					}}
					message={message}
				/>
			)}
		</Fragment>
	);
};

export default ToastContainer;
